
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/e-pooja/temple/pujas/[slug]",
      function () {
        return require("private-next-pages/e-pooja/temple/pujas/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/e-pooja/temple/pujas/[slug]"])
      });
    }
  